import { Authority } from '@/shared/security/authority';

const Entities = () => import('@/entities/entities.vue');
const UploadFileView = () => import('@/shared/upload/uploadFileView.vue');
/* tslint:disable */
// prettier-ignore

// jhipster-needle-add-entity-to-router-import - JHipster will import entities to the router here

export default [
  // jhipster-needle-add-entity-to-router - JHipster will add entities to the router here
  {
    path: '/',
    component: Entities,
    children: [
      {
        path: 'uploadFiles',
        name: 'uploadFiles',
        component: UploadFileView,
        meta: { authorities: [Authority.USER] },
      },
    ],
  },
]
